// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdminOrganizationsPage_TenantSummaryFragment = { __typename?: 'TenantSummary', id: string, name: string, subdomain: string, orgMembershipType?: Types.TenantOrgMembershipType | null, luminaryOrganization?: { __typename?: 'LuminaryOrganization', id: string } | null };

export type AdminOrganizationsPage_WorkOsOrganizationDomainFragment = { __typename?: 'WorkOSOrganizationDomain', id: string, emailDomain: string };

export type AdminOrganizationsPage_LuminaryOrganizationFragment = { __typename?: 'LuminaryOrganization', id: string, displayName: string, jitEnabledAt?: Time | null, workosOrganization?: { __typename?: 'WorkOSOrganization', id: string, externalID: string, workosConnectionID?: string | null, workosDirectoryID?: string | null, domains: { __typename?: 'WorkOSOrganizationDomainConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'WorkOSOrganizationDomainEdge', node?: (
          { __typename?: 'WorkOSOrganizationDomain' }
          & AdminOrganizationsPage_WorkOsOrganizationDomainFragment
        ) | null } | null> | null } } | null };

export type AdminOrganizationsPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminOrganizationsPageQuery = { __typename?: 'Query', luminaryOrganizations: { __typename?: 'LuminaryOrganizationConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges?: Array<{ __typename?: 'LuminaryOrganizationEdge', node?: (
        { __typename?: 'LuminaryOrganization' }
        & AdminOrganizationsPage_LuminaryOrganizationFragment
      ) | null } | null> | null }, adminListTenants: Array<(
    { __typename?: 'TenantSummary' }
    & AdminOrganizationsPage_TenantSummaryFragment
  )> };

export type AdminOrganizationsPageCreateLuminaryOrganizationMutationVariables = Types.Exact<{
  input: Types.CreateLuminaryOrganizationInput;
}>;


export type AdminOrganizationsPageCreateLuminaryOrganizationMutation = { __typename?: 'Mutation', createLuminaryOrganization: { __typename?: 'CreateLuminaryOrganizationOutput', organization: { __typename?: 'LuminaryOrganization', id: string }, parentTenant: { __typename?: 'Tenant', id: string }, workosOrganization: { __typename?: 'WorkOSOrganization', id: string } } };

export type AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationVariables = Types.Exact<{
  input: Types.CreateLuminaryOrganizationMemberTenantInput;
}>;


export type AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation = { __typename?: 'Mutation', createLuminaryOrganizationMemberTenant: { __typename?: 'Tenant', id: string } };

export type AdminOrganizationsPageUpdateWorkOsOrganizationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateWorkOsOrganizationInput;
}>;


export type AdminOrganizationsPageUpdateWorkOsOrganizationMutation = { __typename?: 'Mutation', updateWorkOSOrganization: { __typename?: 'WorkOSOrganization', id: string } };

export type AdminOrganizationsPageAddWorkOsOrganizationDomainMutationVariables = Types.Exact<{
  input: Types.AddWorkOsOrganizationDomainInput;
}>;


export type AdminOrganizationsPageAddWorkOsOrganizationDomainMutation = { __typename?: 'Mutation', addWorkOSOrganizationDomain: { __typename?: 'WorkOSOrganizationDomain', id: string } };

export type AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation = { __typename?: 'Mutation', deleteWorkOSOrganizationDomain: string };

export type AdminOrganizationsPageSetLuminaryOrganizationJitMutationVariables = Types.Exact<{
  input: Types.SetLuminaryOrganizationJitInput;
}>;


export type AdminOrganizationsPageSetLuminaryOrganizationJitMutation = { __typename?: 'Mutation', setLuminaryOrganizationJIT: { __typename?: 'LuminaryOrganization', id: string } };

export const Operations = {
  Query: {
    AdminOrganizationsPage: 'AdminOrganizationsPage' as const
  },
  Mutation: {
    AdminOrganizationsPageCreateLuminaryOrganization: 'AdminOrganizationsPageCreateLuminaryOrganization' as const,
    AdminOrganizationsPageCreateLuminaryOrganizationMemberTenant: 'AdminOrganizationsPageCreateLuminaryOrganizationMemberTenant' as const,
    AdminOrganizationsPageUpdateWorkOSOrganization: 'AdminOrganizationsPageUpdateWorkOSOrganization' as const,
    AdminOrganizationsPageAddWorkOSOrganizationDomain: 'AdminOrganizationsPageAddWorkOSOrganizationDomain' as const,
    AdminOrganizationsPageDeleteWorkOSOrganizationDomain: 'AdminOrganizationsPageDeleteWorkOSOrganizationDomain' as const,
    AdminOrganizationsPageSetLuminaryOrganizationJIT: 'AdminOrganizationsPageSetLuminaryOrganizationJIT' as const
  },
  Fragment: {
    AdminOrganizationsPage_TenantSummary: 'AdminOrganizationsPage_TenantSummary' as const,
    AdminOrganizationsPage_WorkOSOrganizationDomain: 'AdminOrganizationsPage_WorkOSOrganizationDomain' as const,
    AdminOrganizationsPage_LuminaryOrganization: 'AdminOrganizationsPage_LuminaryOrganization' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const AdminOrganizationsPage_TenantSummaryFragmentDoc = gql`
    fragment AdminOrganizationsPage_TenantSummary on TenantSummary {
  id
  name
  subdomain
  orgMembershipType
  luminaryOrganization {
    id
  }
}
    `;
export const AdminOrganizationsPage_WorkOsOrganizationDomainFragmentDoc = gql`
    fragment AdminOrganizationsPage_WorkOSOrganizationDomain on WorkOSOrganizationDomain {
  id
  emailDomain
}
    `;
export const AdminOrganizationsPage_LuminaryOrganizationFragmentDoc = gql`
    fragment AdminOrganizationsPage_LuminaryOrganization on LuminaryOrganization {
  id
  displayName
  jitEnabledAt
  workosOrganization {
    id
    externalID
    workosConnectionID
    workosDirectoryID
    domains(first: 100) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...AdminOrganizationsPage_WorkOSOrganizationDomain
        }
      }
    }
  }
}
    ${AdminOrganizationsPage_WorkOsOrganizationDomainFragmentDoc}`;
export const AdminOrganizationsPageDocument = gql`
    query AdminOrganizationsPage {
  luminaryOrganizations(first: 100) {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        ...AdminOrganizationsPage_LuminaryOrganization
      }
    }
  }
  adminListTenants {
    ...AdminOrganizationsPage_TenantSummary
  }
}
    ${AdminOrganizationsPage_LuminaryOrganizationFragmentDoc}
${AdminOrganizationsPage_TenantSummaryFragmentDoc}`;

/**
 * __useAdminOrganizationsPageQuery__
 *
 * To run a query within a React component, call `useAdminOrganizationsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminOrganizationsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminOrganizationsPageQuery(baseOptions?: Apollo.QueryHookOptions<AdminOrganizationsPageQuery, AdminOrganizationsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminOrganizationsPageQuery, AdminOrganizationsPageQueryVariables>(AdminOrganizationsPageDocument, withFetchPolicyContext(options));
      }
export function useAdminOrganizationsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminOrganizationsPageQuery, AdminOrganizationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminOrganizationsPageQuery, AdminOrganizationsPageQueryVariables>(AdminOrganizationsPageDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useAdminOrganizationsPageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AdminOrganizationsPageQuery, AdminOrganizationsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminOrganizationsPageQuery, AdminOrganizationsPageQueryVariables>(AdminOrganizationsPageDocument, withFetchPolicyContext(options));
        }
export type AdminOrganizationsPageQueryHookResult = ReturnType<typeof useAdminOrganizationsPageQuery>;
export type AdminOrganizationsPageLazyQueryHookResult = ReturnType<typeof useAdminOrganizationsPageLazyQuery>;
export type AdminOrganizationsPageSuspenseQueryHookResult = ReturnType<typeof useAdminOrganizationsPageSuspenseQuery>;
export type AdminOrganizationsPageQueryResult = Apollo.QueryResult<AdminOrganizationsPageQuery, AdminOrganizationsPageQueryVariables>;
export const AdminOrganizationsPageCreateLuminaryOrganizationDocument = gql`
    mutation AdminOrganizationsPageCreateLuminaryOrganization($input: CreateLuminaryOrganizationInput!) {
  createLuminaryOrganization(input: $input) {
    organization {
      id
    }
    parentTenant {
      id
    }
    workosOrganization {
      id
    }
  }
}
    `;
export type AdminOrganizationsPageCreateLuminaryOrganizationMutationFn = Apollo.MutationFunction<AdminOrganizationsPageCreateLuminaryOrganizationMutation, AdminOrganizationsPageCreateLuminaryOrganizationMutationVariables>;

/**
 * __useAdminOrganizationsPageCreateLuminaryOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminOrganizationsPageCreateLuminaryOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsPageCreateLuminaryOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrganizationsPageCreateLuminaryOrganizationMutation, { data, loading, error }] = useAdminOrganizationsPageCreateLuminaryOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrganizationsPageCreateLuminaryOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AdminOrganizationsPageCreateLuminaryOrganizationMutation, AdminOrganizationsPageCreateLuminaryOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminOrganizationsPageCreateLuminaryOrganizationMutation, AdminOrganizationsPageCreateLuminaryOrganizationMutationVariables>(AdminOrganizationsPageCreateLuminaryOrganizationDocument, options);
      }
export type AdminOrganizationsPageCreateLuminaryOrganizationMutationHookResult = ReturnType<typeof useAdminOrganizationsPageCreateLuminaryOrganizationMutation>;
export type AdminOrganizationsPageCreateLuminaryOrganizationMutationResult = Apollo.MutationResult<AdminOrganizationsPageCreateLuminaryOrganizationMutation>;
export type AdminOrganizationsPageCreateLuminaryOrganizationMutationOptions = Apollo.BaseMutationOptions<AdminOrganizationsPageCreateLuminaryOrganizationMutation, AdminOrganizationsPageCreateLuminaryOrganizationMutationVariables>;
export const AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantDocument = gql`
    mutation AdminOrganizationsPageCreateLuminaryOrganizationMemberTenant($input: CreateLuminaryOrganizationMemberTenantInput!) {
  createLuminaryOrganizationMemberTenant(input: $input) {
    id
  }
}
    `;
export type AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationFn = Apollo.MutationFunction<AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation, AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationVariables>;

/**
 * __useAdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation__
 *
 * To run a mutation, you first call `useAdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation, { data, loading, error }] = useAdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation(baseOptions?: Apollo.MutationHookOptions<AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation, AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation, AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationVariables>(AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantDocument, options);
      }
export type AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationHookResult = ReturnType<typeof useAdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation>;
export type AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationResult = Apollo.MutationResult<AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation>;
export type AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationOptions = Apollo.BaseMutationOptions<AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutation, AdminOrganizationsPageCreateLuminaryOrganizationMemberTenantMutationVariables>;
export const AdminOrganizationsPageUpdateWorkOsOrganizationDocument = gql`
    mutation AdminOrganizationsPageUpdateWorkOSOrganization($id: ID!, $input: UpdateWorkOSOrganizationInput!) {
  updateWorkOSOrganization(id: $id, input: $input) {
    id
  }
}
    `;
export type AdminOrganizationsPageUpdateWorkOsOrganizationMutationFn = Apollo.MutationFunction<AdminOrganizationsPageUpdateWorkOsOrganizationMutation, AdminOrganizationsPageUpdateWorkOsOrganizationMutationVariables>;

/**
 * __useAdminOrganizationsPageUpdateWorkOsOrganizationMutation__
 *
 * To run a mutation, you first call `useAdminOrganizationsPageUpdateWorkOsOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsPageUpdateWorkOsOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrganizationsPageUpdateWorkOsOrganizationMutation, { data, loading, error }] = useAdminOrganizationsPageUpdateWorkOsOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrganizationsPageUpdateWorkOsOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AdminOrganizationsPageUpdateWorkOsOrganizationMutation, AdminOrganizationsPageUpdateWorkOsOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminOrganizationsPageUpdateWorkOsOrganizationMutation, AdminOrganizationsPageUpdateWorkOsOrganizationMutationVariables>(AdminOrganizationsPageUpdateWorkOsOrganizationDocument, options);
      }
export type AdminOrganizationsPageUpdateWorkOsOrganizationMutationHookResult = ReturnType<typeof useAdminOrganizationsPageUpdateWorkOsOrganizationMutation>;
export type AdminOrganizationsPageUpdateWorkOsOrganizationMutationResult = Apollo.MutationResult<AdminOrganizationsPageUpdateWorkOsOrganizationMutation>;
export type AdminOrganizationsPageUpdateWorkOsOrganizationMutationOptions = Apollo.BaseMutationOptions<AdminOrganizationsPageUpdateWorkOsOrganizationMutation, AdminOrganizationsPageUpdateWorkOsOrganizationMutationVariables>;
export const AdminOrganizationsPageAddWorkOsOrganizationDomainDocument = gql`
    mutation AdminOrganizationsPageAddWorkOSOrganizationDomain($input: AddWorkOSOrganizationDomainInput!) {
  addWorkOSOrganizationDomain(input: $input) {
    id
  }
}
    `;
export type AdminOrganizationsPageAddWorkOsOrganizationDomainMutationFn = Apollo.MutationFunction<AdminOrganizationsPageAddWorkOsOrganizationDomainMutation, AdminOrganizationsPageAddWorkOsOrganizationDomainMutationVariables>;

/**
 * __useAdminOrganizationsPageAddWorkOsOrganizationDomainMutation__
 *
 * To run a mutation, you first call `useAdminOrganizationsPageAddWorkOsOrganizationDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsPageAddWorkOsOrganizationDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrganizationsPageAddWorkOsOrganizationDomainMutation, { data, loading, error }] = useAdminOrganizationsPageAddWorkOsOrganizationDomainMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrganizationsPageAddWorkOsOrganizationDomainMutation(baseOptions?: Apollo.MutationHookOptions<AdminOrganizationsPageAddWorkOsOrganizationDomainMutation, AdminOrganizationsPageAddWorkOsOrganizationDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminOrganizationsPageAddWorkOsOrganizationDomainMutation, AdminOrganizationsPageAddWorkOsOrganizationDomainMutationVariables>(AdminOrganizationsPageAddWorkOsOrganizationDomainDocument, options);
      }
export type AdminOrganizationsPageAddWorkOsOrganizationDomainMutationHookResult = ReturnType<typeof useAdminOrganizationsPageAddWorkOsOrganizationDomainMutation>;
export type AdminOrganizationsPageAddWorkOsOrganizationDomainMutationResult = Apollo.MutationResult<AdminOrganizationsPageAddWorkOsOrganizationDomainMutation>;
export type AdminOrganizationsPageAddWorkOsOrganizationDomainMutationOptions = Apollo.BaseMutationOptions<AdminOrganizationsPageAddWorkOsOrganizationDomainMutation, AdminOrganizationsPageAddWorkOsOrganizationDomainMutationVariables>;
export const AdminOrganizationsPageDeleteWorkOsOrganizationDomainDocument = gql`
    mutation AdminOrganizationsPageDeleteWorkOSOrganizationDomain($id: ID!) {
  deleteWorkOSOrganizationDomain(id: $id)
}
    `;
export type AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationFn = Apollo.MutationFunction<AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation, AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationVariables>;

/**
 * __useAdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation__
 *
 * To run a mutation, you first call `useAdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrganizationsPageDeleteWorkOsOrganizationDomainMutation, { data, loading, error }] = useAdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation(baseOptions?: Apollo.MutationHookOptions<AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation, AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation, AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationVariables>(AdminOrganizationsPageDeleteWorkOsOrganizationDomainDocument, options);
      }
export type AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationHookResult = ReturnType<typeof useAdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation>;
export type AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationResult = Apollo.MutationResult<AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation>;
export type AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationOptions = Apollo.BaseMutationOptions<AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutation, AdminOrganizationsPageDeleteWorkOsOrganizationDomainMutationVariables>;
export const AdminOrganizationsPageSetLuminaryOrganizationJitDocument = gql`
    mutation AdminOrganizationsPageSetLuminaryOrganizationJIT($input: SetLuminaryOrganizationJITInput!) {
  setLuminaryOrganizationJIT(input: $input) {
    id
  }
}
    `;
export type AdminOrganizationsPageSetLuminaryOrganizationJitMutationFn = Apollo.MutationFunction<AdminOrganizationsPageSetLuminaryOrganizationJitMutation, AdminOrganizationsPageSetLuminaryOrganizationJitMutationVariables>;

/**
 * __useAdminOrganizationsPageSetLuminaryOrganizationJitMutation__
 *
 * To run a mutation, you first call `useAdminOrganizationsPageSetLuminaryOrganizationJitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminOrganizationsPageSetLuminaryOrganizationJitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminOrganizationsPageSetLuminaryOrganizationJitMutation, { data, loading, error }] = useAdminOrganizationsPageSetLuminaryOrganizationJitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminOrganizationsPageSetLuminaryOrganizationJitMutation(baseOptions?: Apollo.MutationHookOptions<AdminOrganizationsPageSetLuminaryOrganizationJitMutation, AdminOrganizationsPageSetLuminaryOrganizationJitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminOrganizationsPageSetLuminaryOrganizationJitMutation, AdminOrganizationsPageSetLuminaryOrganizationJitMutationVariables>(AdminOrganizationsPageSetLuminaryOrganizationJitDocument, options);
      }
export type AdminOrganizationsPageSetLuminaryOrganizationJitMutationHookResult = ReturnType<typeof useAdminOrganizationsPageSetLuminaryOrganizationJitMutation>;
export type AdminOrganizationsPageSetLuminaryOrganizationJitMutationResult = Apollo.MutationResult<AdminOrganizationsPageSetLuminaryOrganizationJitMutation>;
export type AdminOrganizationsPageSetLuminaryOrganizationJitMutationOptions = Apollo.BaseMutationOptions<AdminOrganizationsPageSetLuminaryOrganizationJitMutation, AdminOrganizationsPageSetLuminaryOrganizationJitMutationVariables>;